import React,{useEffect,useRef,useState} from 'react';
import {useLocation} from 'react-router-dom';
import {Bell} from 'lucide-react';
import {queryDaBusca} from '../utils/minhasBuscas';
import {rotaBusca} from '../utils/rotas';
import './BuscaExperiencia.css';
export default function AvisosBuscas(){
 const location=useLocation(),[buscas,setBuscas]=useState([]),[aberto,setAberto]=useState(false),[erro,setErro]=useState(false),ref=useRef(null);
 useEffect(()=>{
  let ativo=true,ocupado=false,controller;
  const carregar=async()=>{
   const token=sessionStorage.getItem('token');
   if(!token||document.hidden||ocupado)return;
   ocupado=true;controller=new AbortController();
   try{
    const r=await fetch(`${process.env.REACT_APP_API_URL||''}/api/filtros/buscas`,{headers:{Authorization:`Bearer ${token}`},signal:controller.signal});
    if(!r.ok)throw new Error();
    const data=await r.json();if(ativo){setBuscas((data.buscas||[]).filter(b=>b.novos>0));setErro(false);}
   }catch(e){if(ativo&&e.name!=='AbortError')setErro(true);}finally{ocupado=false;}
  };
  carregar();const timer=setInterval(carregar,60000);
  window.addEventListener('lc:buscas-atualizadas',carregar);document.addEventListener('visibilitychange',carregar);
  return()=>{ativo=false;controller?.abort();clearInterval(timer);window.removeEventListener('lc:buscas-atualizadas',carregar);document.removeEventListener('visibilitychange',carregar);};
 },[]);
 useEffect(()=>{setAberto(false);},[location.pathname,location.search]);
 useEffect(()=>{if(!aberto)return;const fechar=e=>{if(e.key==='Escape'||(e.type==='pointerdown'&&!ref.current?.contains(e.target)))setAberto(false);};document.addEventListener('pointerdown',fechar);document.addEventListener('keydown',fechar);return()=>{document.removeEventListener('pointerdown',fechar);document.removeEventListener('keydown',fechar);};},[aberto]);
 const total=buscas.reduce((n,b)=>n+b.novos,0);
 return <div className="lc-saved-alerts" ref={ref}>
  <button type="button" className="lc-alert-bell" aria-label={`Novidades das buscas${total?`: ${total} novos resultados`:''}`} aria-expanded={aberto} onClick={()=>setAberto(x=>!x)}><Bell size={19}/>{total>0&&<span>{total>99?'99+':total}</span>}</button>
  {aberto&&<section className="lc-alert-panel" aria-label="Avisos das buscas salvas">
   <strong>Novidades das suas buscas</strong>
   {erro&&<p role="status">Não foi possível atualizar agora. Tentaremos novamente.</p>}
   {!erro&&!buscas.length&&<p>Nenhum imóvel novo nas buscas salvas.</p>}
   {buscas.map(b=><a key={b.id} href={`${rotaBusca(location.pathname)}?${queryDaBusca(b.query)}&buscaSalva=${b.id}&somenteNovos=1`}><b>{b.nome}</b><span>{b.novos} {b.novos===1?'novo imóvel':'novos imóveis'}</span></a>)}
   <small>Abrir o aviso não marca os imóveis como vistos. Um imóvel pode aparecer em mais de uma busca.</small>
  </section>}
 </div>;
}
